export const LOCALES = {
    ENGLISH: 'en',
    FRENCH: 'fr'
};